import React from 'react'
import {DividerWrapper} from './CDElements'
const Divider = () => {
    return (
        <DividerWrapper>
            <>
            
            </>
        </DividerWrapper>
    )
}

export default Divider
